import { render } from "./ClinicReferralOverlay.vue?vue&type=template&id=8521fc8e&lang=pug"
import script from "./ClinicReferralOverlay.vue?vue&type=script&lang=js"
export * from "./ClinicReferralOverlay.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__